const isValidName = (name) => {
    return /^[a-zA-Z\s]{2,}$/.test(name)
}

export default isValidName;